import { FC } from 'react';
import { Link } from 'react-router-dom';
import { DropDownSVG, MarketPlaceSVG } from '../../../svgs';
import { ACCOUNT_PATHS, MARKETPLACE_PATHS } from '../../../../constants/routePaths';
import { NAVIGATION_LINK_CONSTANTS } from '../../../../constants/common';

type MarketplaceLinksProps = {
  currentRoute: string[];
  showMarketplaceOptions: boolean;
  setShowMarketplaceOptions: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenNavBar: React.Dispatch<React.SetStateAction<boolean>>;
};

const MarketplaceLinks: FC<MarketplaceLinksProps> = ({
  currentRoute,
  showMarketplaceOptions,
  setShowMarketplaceOptions,
  setOpen,
  setOpenNavBar,
}) => {
  const activeLinkClass = (path: string) => {
    return currentRoute.includes(path) ? 'nav-link active' : 'nav-link';
  };

  const activeSubLinkClass = (path: string) => {
    return currentRoute.includes(path) ? 'nav-sub-link active' : 'nav-sub-link';
  };

  const isMarketPlaceActive = () =>
    currentRoute.includes(ACCOUNT_PATHS.MARKETPLACE) &&
    !currentRoute.includes(MARKETPLACE_PATHS.MY_LISTING) &&
    !currentRoute.includes(MARKETPLACE_PATHS.MY_ORDERS);

  const closeSideBar = () => {
    setOpen(false);
    setOpenNavBar(false);
  };

  return (
    <div>
      <button
        type="button"
        className={activeLinkClass(ACCOUNT_PATHS.MARKETPLACE)}
        onClick={() => setShowMarketplaceOptions(!showMarketplaceOptions)}>
        <MarketPlaceSVG />
        {NAVIGATION_LINK_CONSTANTS.MARKETPLACE}
        <DropDownSVG reversed={showMarketplaceOptions} />
      </button>
      {showMarketplaceOptions && (
        <div>
          <Link
            className={isMarketPlaceActive() ? 'nav-sub-link active' : 'nav-sub-link'}
            to={ACCOUNT_PATHS.MARKETPLACE}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.MARKET_PLACE}
          </Link>
          <Link
            className={activeSubLinkClass(MARKETPLACE_PATHS.MY_LISTING)}
            to={ACCOUNT_PATHS.MARKETPLACE_ + MARKETPLACE_PATHS.MY_LISTING}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.MY_LISTING}
          </Link>
          <Link
            className={activeSubLinkClass(MARKETPLACE_PATHS.MY_ORDERS)}
            to={ACCOUNT_PATHS.MARKETPLACE_ + MARKETPLACE_PATHS.MY_ORDERS}
            onClick={closeSideBar}>
            {NAVIGATION_LINK_CONSTANTS.MY_ORDERS}
          </Link>
        </div>
      )}
    </div>
  );
};

export default MarketplaceLinks;
